<template>
  <div
    class="web-opetate"
    :style="{
      backgroundImage: 'url(' + dataInfo.cover + ')'
    }"
  >
    <div class="g-box">
      <div class="opetate-title">
        <div class="tt">Cooperative enterprise</div>
        <div class="tit">合作企业</div>
      </div>
      <div class="inner-img">
        <img @click="toDetail" :src="contentInfo.image" alt="" class="img" />
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      contentInfo: {},
      banner: {}
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 1,
      menuId: this.menuId
    });
    this.contentInfo = data[0];
    this.dataInfo = dataInfo;
  },
  methods: {
    toDetail() {
      this.toUrl(this.contentInfo.url);
    }
  }
};
</script>
<style lang="less">
.web-opetate {
  padding-top: 96px;
  width: 100%;
  height: 780px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-sizing: border-box;
  .opetate-title {
    .tt {
      font-size: 60px;
      font-family: "en-tit";
      line-height: 72px;
      color: rgba(255, 255, 255, 0);
      -webkit-text-stroke: 1px #fff;
      text-transform: uppercase;
      text-stroke: 1px #fff;
    }
    .tit {
      font-size: 40px;
      font-family: Dream-LiHeiGB, Dream;
      color: #fff;
      line-height: 45px;
    }
  }
  .img {
    margin: 78px auto 0;
    width: 1200px;
    height: 380px;
  }
}
</style>
